import PropTypes from "prop-types"
import { AutoAwesome, Close, Delete } from "@mui/icons-material"
import { Divider, IconButton } from "@mui/material"
import useFetchMessages from "../../hooks/fetch-messages"
import AiTeammateHeaderMetadata from "./metadata"
import "./style.scss"

export default function AiTeammateHeader({ onReset, onClose }) {
  const { hasMessages } = useFetchMessages()

  return <div className="ai-teammate-header">
    <div className="header-top">
      <div className="header-left">
        <AutoAwesome color="primary" />
        <span className="title">AI Teammate</span>
        <span className="beta-tag">beta</span>
      </div>
      <div className="header-right">
        <IconButton disabled={!hasMessages} onClick={onReset} title="Reset chat">
          <Delete />
        </IconButton>
        <IconButton onClick={onClose} title="Close">
          <Close />
        </IconButton>
      </div>
    </div>
    <Divider />
    <AiTeammateHeaderMetadata />
    <Divider />
  </div>
}

AiTeammateHeader.propTypes = {
  onReset: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
